import Button from "ds/components/Button";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import SplitControlButton from "ds/components/SplitControl/Button";
import SplitControlDropdown from "ds/components/SplitControl/Dropdown";
import SplitControlWrapper from "ds/components/SplitControl/Wrapper";
import { SlackEnvironment } from "types/generated";
import { isSelfHostedDistribution } from "utils/distribution";
import { isFedRampRegion } from "utils/region";

import { openSetUpDrawer } from "./SetUp";
import useConnectSlackIntegration from "./useConnectSlackIntegration";

const isSelfHosted = isSelfHostedDistribution();
const isFedRamp = isFedRampRegion();

type SettingsIntegrationsSlackConnectButtonProps = {
  hasIntegration: boolean;
  hasAppConfig?: boolean;
};

const SettingsIntegrationsSlackConnectButton = ({
  hasIntegration,
  hasAppConfig,
}: SettingsIntegrationsSlackConnectButtonProps) => {
  const { connectSlackIntegration, loading } = useConnectSlackIntegration();

  const handleSetUpSlackAppForSH = () => {
    openSetUpDrawer();
  };

  if (isSelfHosted) {
    if (!hasAppConfig && !hasIntegration)
      return (
        <Button variant="primary" onPress={handleSetUpSlackAppForSH}>
          Set up
        </Button>
      );

    if (hasAppConfig && !hasIntegration)
      return (
        <Button variant="primary" onPress={() => connectSlackIntegration()} loading={loading}>
          Connect
        </Button>
      );

    return null;
  } else {
    if (!hasIntegration) {
      if (isFedRamp) {
        return (
          <SplitControlWrapper variant="primary" size="medium">
            <SplitControlButton onPress={() => connectSlackIntegration()} loading={loading}>
              Connect
            </SplitControlButton>
            <SplitControlDropdown tooltip="Select Slack environment">
              <DropdownMenuItem
                onAction={() => connectSlackIntegration(SlackEnvironment.Commercial)}
              >
                Connect to Commercial Slack
              </DropdownMenuItem>
              <DropdownMenuItem onAction={() => connectSlackIntegration(SlackEnvironment.Govslack)}>
                Connect to GovSlack
              </DropdownMenuItem>
            </SplitControlDropdown>
          </SplitControlWrapper>
        );
      }

      return (
        <Button variant="primary" onPress={() => connectSlackIntegration()} loading={loading}>
          Connect
        </Button>
      );
    }

    return null;
  }
};

export default SettingsIntegrationsSlackConnectButton;
